export default __webpack_public_path__ + "static/media/lundy.51f9bc72.jpg";